import React, { useEffect, useState } from "react";
import { useFetch } from "../../../Hooks/useFetch";
import Spinner from "../Spinner";
// eslint-disable-next-line

// Icons
import {
  BiEditAlt,
  BiTrash,
  BiChevronsRight,
  BiChevronsLeft,
} from "react-icons/bi";
import { BiBox } from "react-icons/bi";


const PaginatedTableWithFetch = (props) => {
  const [initPageIndex, setInitPageIndex] = useState(0);
  const [endPageIndex, setEndPageIndex] = useState(props.pageSize);
  const [paginateIndex, setPaginateIndex] = useState(1);
  const [filteredIds, setFilteredIds] = useState([]);
  const [filteredData, setFilteredData] = useState([]);


  // 🧐 Chamada da api de lista com swr
  const { data, error, isDisabled, loading } = useFetch(props.api);

  useEffect(() => {
    if (!data) return; // evita erro se data ainda não carregou

    // 🔹 Filtra sempre por active !== 'N'
    let activeData = data.filter((d) => d.active !== "N");

    // 🔹 Se tiver filteredIds, aplica o filtro adicional
    if (filteredIds.length > 0) {
      activeData = activeData.filter((d) =>
        filteredIds.includes(
          d.automakerId ?? d.colorId ?? d.categoryId ?? d.modelId
        )
      );
    }

    setFilteredData(activeData);
  }, [data, filteredIds]);


  const onEdit = (item) => props.onEdit(item);
  const onDelete = (item) => props.onDelete(item);

  const amountPages = () => {
    var division = data.length / props.pageSize;
    var remainder = division % 1;
    var quotient = division - remainder;
    if (remainder > 0) quotient += 1;
    return quotient;
  };

  const onPaginate = (index) => {
    if (index > 0 && index <= amountPages()) {
      setPaginateIndex(index);
      setInitPageIndex(index * props.pageSize - props.pageSize); // 3*10-10 = 20
      setEndPageIndex(index * props.pageSize); // 3*10 = 30
    }
  };

  const buttons = (item) => {
    return (
      <>
        <div className='row'>
          <div className='col-6'>
            <BiEditAlt className='icon-button' onClick={() => onEdit(item)} />
          </div>
          <div className='col-6'>
            <BiTrash className='icon-button' onClick={() => onDelete(item)} />
          </div>
        </div>
      </>
    );
  };

  const onSearch = (filter) => {
    const searchTerm = filter.trim().toUpperCase();

    if (!searchTerm) {
      // Se filtro estiver vazio, mostra todos
      const allIds = data.map((row) => row.automakerId ?? row.colorId ?? row.categoryId);
      setFilteredIds(allIds);
      return;
    }

    const matchingIds = data
      .filter((row) =>
        ["automakerId", "description"].some((field) => {
          const value = row[field];
          return (
            value &&
            value.toString().toUpperCase().includes(searchTerm)
          );
        })
      )
      .map((row) => row.automakerId ?? row.colorId ?? row.categoryId); // usa automakerId, senão colorId

    setFilteredIds(matchingIds);
  };



  if (error)
    return (
      <h6 style={{ color: "red", paddingLeft: "20px" }}>
        Não foi possível carregar os dados
      </h6>
    );

  if (isDisabled) {
    return (
      <div className="alert alert-warning" style={{ margin: '20px' }}>
        Selecione uma montadora para visualizar os modelos.
      </div>
    );
  }

  if (loading) return <Spinner />;

  if (!data || data.length === 0) {
    return (
      <div className="alert alert-info" style={{ margin: "20px", textAlign: "center" }}>
        <BiBox size={50} style={{ marginBottom: "10px", opacity: 0.5 }} />
        <div>Nenhum dado disponível</div>
      </div>
    );
  }






  return (
    <>
      <div className='d-flex align-items-end flex-column bd-highlight mb-3'>
        <div className='p-2 bd-highlight'>
          <input
            id='table-search'
            className='form-control me-2'
            type='search'
            placeholder='Pesquisa'
            aria-label='Search'
            onChange={(e) => onSearch(e.target.value)}
          />
        </div>
      </div>

      <div className='table-responsive text-nowrap'>
        <table className='table' id='paginated-table'>
          <thead>
            <tr>
              {props.columns &&
                props.columns.map((column, index) => (
                  <th key={index}>{column}</th>
                ))}
              <th>Ações</th>
            </tr>
          </thead>
          <tbody className='table-border-bottom-0'>
            {filteredData &&
              filteredData.map((item, index) =>
                index >= initPageIndex && index < endPageIndex ? (
                  <tr key={index}>
                    <td>{item.automakerId ?? item.colorId ?? item.categoryId}</td>
                    <td>{item.description}</td>
                    <td>{item.active}</td>
                    <td className='action-table-col'>
                      {item.hasOwnProperty("infoCar") ? (
                        item["infoCar"] === "N" ? (
                          <>{buttons(item)}</>
                        ) : (
                          ""
                        )
                      ) : (
                        <>{buttons(item)}</>
                      )}
                    </td>
                  </tr>
                ) : (
                  ""
                )
              )}
          </tbody>

        </table>

        <nav aria-label='Page navigation'>
          <ul className='pagination'>
            <li className='page-item'>
              <button
                className='page-link'
                onClick={() => onPaginate(paginateIndex - 1)}>
                <BiChevronsLeft />
              </button>
            </li>

            {data &&
              Array.from({ length: amountPages() }, (_, i) => i + 1).map(
                (item, itemIndex) => (
                  <li
                    key={itemIndex}
                    className={`page-item ${paginateIndex === item ? "active" : ""
                      }`}>
                    <button
                      className='page-link'
                      onClick={() => onPaginate(item)}>
                      {item}
                    </button>
                  </li>
                )
              )}

            <li className='page-item '>
              <button
                className='page-link'
                onClick={() => onPaginate(paginateIndex + 1)}>
                <BiChevronsRight />
              </button>
            </li>
          </ul>
        </nav>
      </div>
    </>
  );
};
export default PaginatedTableWithFetch;
